// routes/LoginRoute.tsx
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export default function LoginRoute() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect();
  }, [loginWithRedirect]);

  return <p>Redirecting to login...</p>;
}